import { PlatformSiteAri } from '@atlassian/ari';

import { ActivitiesObjectType, ActivityEventType } from '../homeViewsQueryHelpers.ts';

import { HomeRecentCreatedQuery, HomeRecentActivityQuery } from './HomeRecentQueries.graphql.ts';

const WORKED_ON_EVENT_TYPES_V3 = [
	ActivityEventType.EDITED,
	ActivityEventType.PUBLISHED,
	ActivityEventType.UPDATED,
	ActivityEventType.CREATED,
	ActivityEventType.STARTED,
	ActivityEventType.SNAPSHOTTED,
];

const COLLABORATED_ON_EVENT_TYPES = [ActivityEventType.COMMENTED, ...WORKED_ON_EVENT_TYPES_V3];

const OBJECT_TYPES = [
	ActivitiesObjectType.PAGE,
	ActivitiesObjectType.BLOGPOST,
	ActivitiesObjectType.EMBED,
];

const PAGE_SIZE = 24;

export const getRecentQueryOptions = ({
	pill,
	cloudId,
	endCursor,
	isWhiteboardViewedEnabled,
	isWhiteboardUpdatedEnabled,
	isDatabaseEnabled,
}: {
	pill: string | undefined;
	cloudId: string;
	endCursor: string;
	isWhiteboardViewedEnabled?: boolean;
	isWhiteboardUpdatedEnabled?: boolean;
	isDatabaseEnabled?: boolean;
}) => {
	const createdDateFilter = 'and created >= startOfDay("-90d") ';

	const activityQuery = HomeRecentActivityQuery;
	const activityCloudId = PlatformSiteAri.create({ siteId: cloudId }).toString();

	switch (pill) {
		case 'created':
			return {
				query: HomeRecentCreatedQuery,
				variables: {
					cql: `type in (page, blogpost, embed${
						isWhiteboardUpdatedEnabled ? ', whiteboard' : ''
					}${isDatabaseEnabled ? ', database' : ''}) and owner=currentUser() ${createdDateFilter}order by created desc`,
					cqlcontext: `{"contentStatuses":["draft", "current"]}`,
					first: PAGE_SIZE,
					after: endCursor,
				},
			};
		case 'worked-on':
			return {
				query: activityQuery,
				variables: {
					cloudId: activityCloudId,
					first: PAGE_SIZE,
					after: endCursor,
					eventTypes: WORKED_ON_EVENT_TYPES_V3,
					objectTypes: [
						...OBJECT_TYPES,
						ActivitiesObjectType.CONTENT,
						...(isWhiteboardUpdatedEnabled ? [ActivitiesObjectType.WHITEBOARD] : []),
						...(isDatabaseEnabled ? [ActivitiesObjectType.DATABASE] : []),
					],
				},
			};
		case 'collaborated-on':
			return {
				query: activityQuery,
				variables: {
					cloudId: PlatformSiteAri.create({ siteId: cloudId }).toString(),
					first: PAGE_SIZE,
					after: endCursor,
					eventTypes: COLLABORATED_ON_EVENT_TYPES,
					objectTypes: [
						...OBJECT_TYPES,
						...(isWhiteboardUpdatedEnabled ? [ActivitiesObjectType.WHITEBOARD] : []),
						...(isDatabaseEnabled ? [ActivitiesObjectType.DATABASE] : []),
						ActivitiesObjectType.CONTENT,
						ActivitiesObjectType.COMMENT,
					],
				},
			};
		case 'all':
		default:
			return {
				query: activityQuery,
				variables: {
					cloudId: activityCloudId,
					first: PAGE_SIZE,
					after: endCursor,
					eventTypes: [],
					objectTypes: [
						...OBJECT_TYPES,
						ActivitiesObjectType.CONTENT,
						...(isWhiteboardViewedEnabled ? [ActivitiesObjectType.WHITEBOARD] : []),
						...(isDatabaseEnabled ? [ActivitiesObjectType.DATABASE] : []),
					],
				},
			};
	}
};
